var configoverride = {};

configoverride.brand = "tolkcontact";

/****************************************************************************************************/
// APPLICATION MODE
/****************************************************************************************************/
configoverride.mode = {
    anonymous_enabled: false, //Anonymous login enabled
    anonymous_autologin: false, //Login as anonymous automatically
    authenticated_enabled: false, //Authenticated login enabled
    services_enabled: false, //Services tab visible
    contacts_enabled: false, //Contacts tab visible
    call_enabled: false, //Call tab visible
    history_enabled: false, //History tab visible
    messages_enabled: false, //Message tab visible
    settings_enabled: false, //Settings tab visible
    display_settings_in_menu: false, //Display settings instead of account in menu
    logout_enabled: false, //Show logout button
    name_enabled: false, //Shows name in top right corner
    online_enabled: false, //Online symbol visible in
    home: "services", //Home page. Possible values: services, contacts, call, history, messages
    kiosk: false, //Kiosk mode
    kiosk_main_layout: false, //Use the "normal" layout in kiosk mode
    restrict: false, //Restrict Kiosk to only call registred numbers
    inIframe: false, //Can the page be displayed in an iFrame
    forceIframe: false, //Must the page be displayed in an iFrame
    registration_enabled: false, //Registration enabled
    resetpassword_enabled: true, //Reset password enabled
    changeuser_enabled: false, //Change user account enabled
    setting_text_enabled: true, //Enable change text on settings
    setting_text_visible_by_default: false, //Whether the text should be visible by default or not
    setting_ringtone_enabled: false, //Enable change ringtone in settings
    setting_media_enabled: false, //Enable change used media on settings
    setting_message_enabled: false, //Enable change message on settings
    text_in_footer: false, // Display Call with audio ON/OFF in footer
    use_double_audio_icons_in_footer: false, //Dsiplay both mic and speaker in footer
    buttons_in_footer: true, //Show media buttons in footer
    link_to_settings_in_footer: false, // Display link to media settings in footer
    debug_enabled: false, //Enable debug
    debug_enabled_in_menu: false, //Enable debug in menu
    register_with_userpart_from_sip: false, // Use the userpart from the SIP-address instead of username in register
    dialpad: false, //Enable or disable the in call dialpad
    audio: true, //Enable/disable audio
    video: false, //Enable/disable video
    safetext: false, //Enable/disable text
};

configoverride.registration = {
    orgid: "1",
    recaptcha: true,
    autogeneratepassword: false,
    license: true,
    sendRegistrationMail: true,
};

configoverride.texts = {
    nl: {
        "login.logo.href": "./",
        "common.appOwner": "Tolkcontact",
    }
};

export default configoverride;



// WEBPACK FOOTER //
// ./src/branding/current/configoverride.js